import { FormFieldValidation } from '@moia-dev/pace-web'
import {
  Controller,
  type ControllerProps,
  type FieldValues,
} from 'react-hook-form'
import { Textarea, type TextareaProps } from '../Basic/Textarea'

export type FormTextareaProps<FormFieldValues extends FieldValues> =
  TextareaProps &
    Pick<
      ControllerProps<FormFieldValues>,
      'control' | 'name' | 'rules' | 'disabled' | 'shouldUnregister'
    >

export const FormTextarea = <FormFieldValues extends FieldValues>({
  label,
  name,
  control,
  rules,
  caption,
  disabled,
  shouldUnregister,
  ...props
}: FormTextareaProps<FormFieldValues>) => {
  const maxLength =
    typeof rules?.maxLength === 'number' ? rules.maxLength : undefined
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      shouldUnregister={shouldUnregister}
      render={({ field, fieldState }) => (
        <Textarea
          required={Boolean(rules?.required)}
          maxLength={maxLength}
          caption={caption}
          validation={
            fieldState.error?.message && (
              <FormFieldValidation type="error">
                {fieldState.error.message}
              </FormFieldValidation>
            )
          }
          label={label}
          disabled={disabled}
          {...field}
          {...props}
          error={Boolean(fieldState.error?.type)}
        />
      )}
    />
  )
}
